import React from "react";

export const PageHero = ({ kicker, title, highlight, subtitle, bg, children }) => {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-36 pb-20 overflow-hidden border-b border-border"
    >
      {bg ? (
        <div className="absolute inset-0">
          <img src={bg} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
        </div>
      ) : (
        <div className="absolute inset-0 tex-plate" />
      )}
      <div className="absolute inset-0 tex-grid opacity-40" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {kicker && <p className="label-kicker mb-4">{kicker}</p>}
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9] text-white">
          {title} {highlight && <span className="text-primary">{highlight}</span>}
        </h1>
        {subtitle && (
          <p className="mt-6 text-lg md:text-xl text-gray-300 max-w-3xl leading-relaxed">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
};
